<template>
  <div class="doctor-app">
    <!-- Sidebar -->
    <aside class="doctor-sidebar">
      <div class="doctor-sidebar__logo">
        <img
          class="doctor-sidebar__logo-img"
          src="../assets/images/logo-videomedi-white.png"
          alt="Videomedi"
        />
      </div>

      <nav
        class="doctor-sidebar__nav"
        role="navigation"
        aria-label="Menu do profissional de saúde"
      >
        <router-link
          class="doctor-sidebar__item"
          active-class="doctor-sidebar__item--active"
          to="/dashboard"
          exact
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <rect
              x="3"
              y="3"
              width="7"
              height="9"
              rx="1.5"
              stroke="currentColor"
              stroke-width="2"
            />
            <rect
              x="14"
              y="3"
              width="7"
              height="5"
              rx="1.5"
              stroke="currentColor"
              stroke-width="2"
            />
            <rect
              x="14"
              y="12"
              width="7"
              height="9"
              rx="1.5"
              stroke="currentColor"
              stroke-width="2"
            />
            <rect
              x="3"
              y="16"
              width="7"
              height="5"
              rx="1.5"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
          Dashboard
        </router-link>

        <router-link
          class="doctor-sidebar__item"
          active-class="doctor-sidebar__item--active"
          to="/configurar-agenda"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <rect
              x="3"
              y="4"
              width="18"
              height="17"
              rx="2"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M3 9h18M8 2v4M16 2v4"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
          Agenda
        </router-link>

        <router-link
          class="doctor-sidebar__item"
          active-class="doctor-sidebar__item--active"
          to="/medico/pacientes"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="9"
              cy="8"
              r="3.5"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M2 20c0-3.5 3-5.5 7-5.5s7 2 7 5.5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M17 9h5M19.5 6.5v5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Pacientes
        </router-link>

        <router-link
          v-if="isDoctorUser"
          class="doctor-sidebar__item"
          active-class="doctor-sidebar__item--active"
          to="/medico/clinicas"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M4 21V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16M2 21h20M12 7v6M9 10h6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Clínicas
          <span v-if="pendingInvitations" class="doctor-sidebar__tag">
            {{ pendingInvitations }}
          </span>
        </router-link>

        <router-link
          class="doctor-sidebar__item"
          active-class="doctor-sidebar__item--active"
          to="/financeiro"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <rect
              x="3"
              y="5"
              width="18"
              height="14"
              rx="2"
              stroke="currentColor"
              stroke-width="2"
            />
            <path d="M3 10h18" stroke="currentColor" stroke-width="2" />
          </svg>
          Financeiro
        </router-link>

        <router-link
          class="doctor-sidebar__item"
          active-class="doctor-sidebar__item--active"
          to="/medico/perfil"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="12"
              cy="12"
              r="3"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Configurar
        </router-link>

        <!-- DIAGNÓSTICO TEMPORÁRIO — só aparece para a conta de diagnóstico;
             o backend recusa qualquer outra. Remover junto com o modal. -->
        <button
          v-if="isDiagnosticAccount"
          class="doctor-sidebar__item"
          type="button"
          @click="openDiagnosticModal"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M6 3h6a4 4 0 0 1 0 8H6V3zM6 11l9 10M6 11v10"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Testar prescrição
        </button>

        <!-- <div class="doctor-sidebar__divider" /> -->

        <!-- Área pública — comentado temporariamente
        <a class="doctor-sidebar__item" href="/" target="_blank" rel="noopener">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M12 3c-2.5 3-4 5.5-4 9s1.5 6 4 9M12 3c2.5 3 4 5.5 4 9s-1.5 6-4 9M3 12h18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Área pública
        </a>
        -->

        <button
          class="doctor-sidebar__item doctor-sidebar__item--danger"
          @click="handleLogout"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Sair
        </button>
      </nav>

      <router-link to="/medico/perfil" class="doctor-sidebar__footer">
        <div
          class="avatar avatar--sm"
          :style="
            currentUser.photo
              ? `background-image:url(${currentUser.photo});background-size:cover;background-position:center;`
              : 'background:var(--color-accent-light);color:var(--color-accent)'
          "
        >
          <span v-if="!currentUser.photo">{{ doctorInitials }}</span>
        </div>
        <div class="stack" style="gap:0;overflow:hidden">
          <span class="doctor-sidebar__footer-name">{{ doctorName }}</span>
          <span class="doctor-sidebar__footer-meta">{{ doctorMeta }}</span>
        </div>
      </router-link>
    </aside>

    <!-- Conteúdo principal -->
    <main class="doctor-main">
      <slot />
    </main>

    <!-- DIAGNÓSTICO TEMPORÁRIO — montado só para a conta de diagnóstico. -->
    <prescription-diagnostic-modal v-if="isDiagnosticAccount" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { stripHonorific } from "../utils/name";
import { isDoctor } from "../utils/userRole";
import { isDiagnosticAccount } from "../utils/prescriptionDiagnostic";
import PrescriptionDiagnosticModal from "../components/PrescriptionDiagnosticModal.vue";

export default {
  name: "DoctorApp",
  components: {
    PrescriptionDiagnosticModal
  },
  mounted() {
    document.body.className = "";
    document.body.classList.add("doctor-app-body");
    this.refreshInvitations();
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    handleLogout() {
      this.logout();
    },
    refreshInvitations() {
      if (this.isDoctorUser) this.$store.dispatch("clinicInvitations/refresh");
    },
    openDiagnosticModal() {
      this.$bvModal.show("prescription-diagnostic-modal");
    }
  },
  computed: {
    ...mapGetters("clinicInvitations", { pendingInvitations: "pendingCount" }),
    currentUser() {
      return this.$store.state.user.currentUser || {};
    },
    isDoctorUser() {
      return isDoctor(this.currentUser);
    },
    isDiagnosticAccount() {
      return isDiagnosticAccount(this.currentUser);
    },
    doctorName() {
      const name = stripHonorific(this.currentUser.name);
      return name ? `Dr(a). ${name}` : "";
    },
    doctorInitials() {
      const name = this.currentUser.name || "";
      return name
        .split(" ")
        .slice(0, 2)
        .map(n => n[0])
        .join("")
        .toUpperCase();
    },
    doctorMeta() {
      const dp = this.currentUser.doctor_property;
      if (!dp) return "";
      const spec = dp.speciality_name || "";
      const council = dp.council_description || "";
      return [spec, council].filter(Boolean).join(" · ");
    }
  },
  watch: {
    // Atualiza o contador ao navegar (ex.: depois de aceitar um convite).
    "$route.path"() {
      this.refreshInvitations();
    }
  }
};
</script>

<style lang="scss">
.doctor-sidebar__logo-img {
  display: block;
  height: 28px;
  width: auto;
}

// Variáveis locais (usa tokens do DS V2)
.doctor-app-body {
  background: var(--color-bg-page);
}

.doctor-app {
  display: grid;
  grid-template-columns: 244px 1fr;
  min-height: 100vh;
}

// ============================================================
// Sidebar
// ============================================================
.doctor-sidebar {
  background: var(--color-bg-sidebar);
  padding: var(--space-5) var(--space-3);
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;

  &__logo {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3) var(--space-5);
  }

  &__wordmark {
    font-weight: var(--fw-extra);
    font-size: var(--font-size-xl);
    letter-spacing: -0.02em;
    color: #fff;
  }

  &__nav {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
  }

  &__tag {
    margin-left: auto;
    font-size: 10px;
    font-weight: var(--fw-bold);
    background: var(--color-accent);
    color: #fff;
    border-radius: var(--radius-full);
    padding: 1px 7px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3);
    border-radius: var(--radius-md);
    color: var(--color-gray-400);
    font-size: var(--font-size-sm);
    font-weight: var(--fw-semibold);
    position: relative;
    text-decoration: none;
    transition: background 0.12s, color 0.12s;

    svg {
      flex: none;
    }

    &:hover {
      background: var(--color-bg-sidebar-item);
      color: #fff;
    }

    &--active {
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
    }

    &--disabled {
      opacity: 0.45;
      cursor: default;
      pointer-events: none;
    }
  }

  &__footer {
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3);
    border-top: 1px solid var(--color-bg-sidebar-item);
    text-decoration: none;
    border-radius: var(--radius-md);
    transition: background 0.12s;
    cursor: pointer;

    &:hover {
      background: var(--color-bg-sidebar-item);
    }
  }

  &__footer-name {
    color: #fff;
    font-size: var(--font-size-sm);
    font-weight: var(--fw-semibold);
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__footer-meta {
    color: var(--color-gray-400);
    font-size: var(--font-size-xs);
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__divider {
    height: 1px;
    background: var(--color-bg-sidebar-item);
    margin: var(--space-2) var(--space-3);
  }

  &__item--danger {
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    color: #f87171;

    &:hover {
      background: rgba(248, 113, 113, 0.12);
      color: #fca5a5;
    }
  }
}

// ============================================================
// Área principal
// ============================================================
.doctor-main {
  background: var(--color-bg-page);
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

// ============================================================
// Responsivo
// ============================================================
@media (max-width: 860px) {
  .doctor-app {
    grid-template-columns: 1fr;
  }

  .doctor-sidebar {
    display: none;
  }
}
</style>
